import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../../components/common/Header/Header";
import Modal from "../../../components/common/modal/modal";
import useExpressShieldFlow from "../../../hooks/BuyOnlineExpressShield/useExpressShieldFlow";
import { DETAILS, PLAN, PAYMENT, headerStepperData, FLOW_TYPE_EXPRESS_SHIELD } from "./data";
import Details from "./details/details";
import Plan from "./plan/plan";
import ReviewAndConfirm from "./payment/reviewAndConfirm";
import { useDispatch } from "react-redux";
import { fetchCmsExpressOnlinePlans, fetchCmsQuestionniare } from "../../../redux/features/buyOnlinePlans/expressShieldFlowStrapiCmsSlice";
import { fetchNationalitiesList } from "../../../redux/features/constants/nationalitiesSlice";

const ExpressShieldPlan = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(true);
  const { currentStep, currentStepIndex, currentSubstepIndex, handleFlowChange } =
    useExpressShieldFlow();

  // Which way the step entrance slides: forward on Continue, back on Back.
  // Same scheme as the claim flow (index.css, [data-claim-nav]). Worked out
  // during render, not in an effect: an effect runs after the new page has
  // painted, so the entrance's first frame would carry the old direction.
  const flowPosition = currentStepIndex * 1000 + currentSubstepIndex;
  const navRef = useRef({ position: flowPosition, direction: "forward" });
  if (flowPosition !== navRef.current.position) {
    navRef.current = {
      position: flowPosition,
      direction: flowPosition > navRef.current.position ? "forward" : "back",
    };
  }

  const PageRenderer = () => {
    switch (currentStep?.name) {
      case DETAILS:
        return <Details />;
      case PLAN:
        return <Plan />;
      case PAYMENT:
        return <ReviewAndConfirm />;
      default:
        return null;
    }
  };

  const activeStepData = useMemo(() => {
    let activeStep = headerStepperData.find(
      (each) => each.key ==currentStep.name
    );
    return activeStep;
  }, [currentStep]);

  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(fetchCmsExpressOnlinePlans());
    dispatch(fetchCmsQuestionniare())
    // Requested now rather than when Other Details opens, so the list is
    // there by the time the customer reaches it. Served from the cache when
    // an earlier visit already has it.
    dispatch(fetchNationalitiesList())
    handleFlowChange(FLOW_TYPE_EXPRESS_SHIELD,0)
  }, [])

  return (
    <Modal show={showModal}>
      <Header
        isPopup
        onCloseModal={() => {
          setShowModal(false);
          navigate("/new-policy");
        }}
        showStepper={true}
        steps={headerStepperData}
        activeStep={activeStepData}
      />
      <div
        data-claim-nav={navRef.current.direction}
        className="expressShieldPlan overflow-x-clip max767:overflow-x-hidden pt-[5%] pb-[5%] max767:w-full max767:overflow-y-scroll max767:pb-40 max767:h-screen max767:h-dvh ipad:pt-[10%] ipad:h-[93vh] ipad:overflow-y-scroll max767:p-5 max767:pt-24 max767:bg-white" >
        {PageRenderer()}
      </div>
    </Modal>
  );
};

export default ExpressShieldPlan;
